import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "lp-mortgage-calculator" }
const _hoisted_3 = { class: "row g-lg-4" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "mb-3 mb-lg-4" }
const _hoisted_6 = { class: "mb-3 mb-lg-4 mortgage-calculator__inline-inputs" }
const _hoisted_7 = { class: "mb-3 mb-lg-4" }
const _hoisted_8 = { class: "mb-3 mb-lg-4" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "mortage-calulator__chart" }
const _hoisted_12 = ["id"]
const _hoisted_13 = { class: "calculator__result-row" }
const _hoisted_14 = { class: "calculator-result-row__number" }
const _hoisted_15 = { class: "calculator__result-row" }
const _hoisted_16 = { class: "calculator-result-row__number" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "calculator__result-row" }
const _hoisted_19 = { class: "calculator-result-row__number" }
const _hoisted_20 = { class: "input-group" }
const _hoisted_21 = { class: "lp-calculator-disclaimer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_group_input = _resolveComponent("base-group-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["card", _ctx.cssClass])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_base_group_input, {
                  "required-flag": true,
                  inputLabel: "House Cost",
                  "front-group": "$"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_input, {
                      label: "House Cost",
                      modelValue: _ctx.houseCost,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.houseCost) = $event)),
                      modelModifiers: { number: true },
                      type: "number",
                      placeholder: "200000",
                      "show-label": false
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_base_group_input, {
                  "required-flag": true,
                  inputLabel: "Down Payment",
                  "front-group": "$"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_input, {
                      label: "Down Payment",
                      showLabel: false,
                      modelValue: _ctx.downPaymentNumberDisplay,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.downPaymentNumberDisplay) = $event)),
                      modelModifiers: { number: true },
                      type: "number"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "mortgage-calculator-inline-inputs__middle" }, "or", -1)),
                _createVNode(_component_base_group_input, { "back-group": "%" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_input, {
                      modelValue: _ctx.downPaymentPercDisplay,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.downPaymentPercDisplay) = $event)),
                      type: "number",
                      showLabel: false,
                      label: "Down payment percentage"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[10] || (_cache[10] = _createElementVNode("label", {
                  for: "`input-${inputId}`",
                  class: "form-label"
                }, [
                  _createTextVNode(" Mortgage Term "),
                  _createElementVNode("span", null, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "aria-label": "Mortgage Term",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mortgageTerm) = $event))
                }, _cache[9] || (_cache[9] = [
                  _createElementVNode("option", { value: "30" }, "30 years", -1),
                  _createElementVNode("option", { value: "20" }, "20 years", -1),
                  _createElementVNode("option", { value: "15" }, "15 years", -1),
                  _createElementVNode("option", { value: "10" }, "10 years", -1)
                ]), 512), [
                  [
                    _vModelSelect,
                    _ctx.mortgageTerm,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_base_group_input, {
                  "required-flag": true,
                  inputLabel: "Interest Rate",
                  "back-group": "%"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_input, {
                      label: "Interest Rate",
                      showLabel: false,
                      modelValue: _ctx.interestRate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.interestRate) = $event)),
                      modelModifiers: { number: true },
                      type: "number",
                      step: ".01",
                      placeholder: "3.25"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_base_group_input, {
                  inputLabel: "Estimated Monthly Payment",
                  "front-group": "$"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_input, {
                      label: "Estimated Monthly Payment",
                      modelValue: _ctx.estMonthlyPayment,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.estMonthlyPayment) = $event)),
                      modelModifiers: { number: true },
                      showLabel: false,
                      type: "number",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("canvas", {
                  id: `mortgage-calculator-${_ctx.calculatorId}`
                }, null, 8, _hoisted_12)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "calculator-result-row__dot bg-primary" }, null, -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("p", { class: "calculator-result-row__label" }, " Principal & Interest ", -1)),
                  _createElementVNode("p", _hoisted_14, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatCurrency(_ctx.principalAndInterest)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "calculator-result-row__dot bg-secondary" }, null, -1)),
                  _cache[15] || (_cache[15] = _createElementVNode("p", { class: "calculator-result-row__label" }, " Homeowner's Insurance ", -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "input-group-text" }, "$", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        type: "number",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.homeInsurance) = $event)),
                        "aria-label": "Homeowner's Insurance"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.homeInsurance,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "calculator-result-row__dot bg-success" }, null, -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("p", { class: "calculator-result-row__label" }, "Property Tax", -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "input-group-text" }, "$", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        type: "number",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.propertyTax) = $event)),
                        "aria-label": "Property Tax"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.propertyTax,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("hr", null, null, -1))
        ]),
        _renderSlot(_ctx.$slots, "cta")
      ])
    ], 2),
    _createElementVNode("div", _hoisted_21, [
      _renderSlot(_ctx.$slots, "disclaimer")
    ])
  ], 64))
}